import React from "react";
import "../Css/OurStarStudents.css";

import s1 from "../assets/soham.webp";
import s2 from "../assets/shaila.webp";
import s3 from "../assets/maithili.webp";
import s4 from "../assets/veera.webp";

const students = [
  {
    img: s1,
    name: "Soham Wad",
    percent: "AIR 3023",
    standard: "JEE Advanced",
    text:
      "IITian's Chinmay Academy provided me expert IIT-JEE guidance with strong conceptual clarity. The personalized mentorship and regular problem-solving sessions helped me secure AIR 3023 in JEE Advanced."
  },
  {
    img: s2,
    name: "Shailaja",
    percent: "99.82 Percentile",
    standard: "JEE Mains",
    text:
      "The faculty at IITian's Chinmay Academy are highly experienced IITian's . Their structured JEE Main preparation strategy and doubt-clearing sessions helped me achieve 99.82 percentile."
  },
  {
    img: s3,
    name: "Maithili",
    percent: "91 Percent",
    standard: "10th Standard",
    text:
      "IITian's Chinmay Academy helped me build a strong foundation in Maths and Science from an early stage. Their concept-based teaching boosted my confidence and academic performance."
  },
  {
    img: s4,
    name: "Veera Thipse",
    percent: "92 Percent",
    standard: "Maths & Science",
    text:
      "With guidance from IITian mentors at Chinmay Academy, I improved my problem-solving skills significantly. The focused attention and disciplined study plan helped me score 92 percent."
  }
];


const OurStarStudents = () => {
  return (
    <section className="stars">
      <h2 className="stars-title">Our Star Students</h2>

      <div className="stars-container">
        {students.map((s, i) => (
          <div className="star-card" key={i}>
            <div className="star-img">
              <img src={s.img} alt={s.name} />
            </div>

            <h3>{s.name}</h3>
            <span className="score">{s.percent}</span>
            <span className="class">{s.standard}</span>

            <div className="divider"></div>

            <p>{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurStarStudents;
